import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { ExternalBundlesLoader } from './external-bundles-loader';

export type WebappScripts = 'stripe' | 'hotjar';

@Injectable({ providedIn: 'root' })
export class DocumentExternalScriptsLoader extends ExternalBundlesLoader<WebappScripts> {
  constructor(@Inject(DOCUMENT) public document: Document) {
    super(document);
  }
}
